<div class="segmented-progress-container">
  <div class="segmented-progress-bar">
    @for (segment of segments; track segment; let i = $index; let isLast = $last) {
      <div
        class="progress-segment"
        [class.segment-color]="segment.color"
        [attr.data-color]="segment.color"
        [style.width.%]="getSegmentWidth(segment)"
        [class.has-value]="segment.value > 0"
        >
        <div class="blur-border"></div>
        <div class="solid-border"></div>
      </div>
    }
  </div>

  @if (showLabels && segments.length > 0) {
    <div class="segment-labels">
      @for (segment of segments; track segment) {
        <div class="segment-label">
          <div class="label-indicator" [attr.data-color]="segment.color"></div>
          <hyperkit-typography variant="emphasized" size="sm" color="secondary">
            {{ segment.label }}:
            {{
            showPercentages
            ? (getSegmentPercentage(segment) | number: '1.0-0') + '%'
            : segment.value
            }}
          </hyperkit-typography>
        </div>
      }
    </div>
  }
</div>
